app.directive('prescribedDrugs', ['userModel', 'prescribedDrugModel', 'applicationModel', 'visitCardModel', '$mdDialog',
    function(userModel, prescribedDrugModel, applicationModel, visitCardModel, $mdDialog) {
        var definition = {
            restrict: 'E',
            replace: true,
            require: '^form',
            scope: {
                patient: '=',
                visit: '=',
                visitCard: '=',
                template: '=',
                updatePrescription: '&',
                createPrescription: '&',
                blinkAction: '&',
                inputLabel: '@'
            },
            templateUrl: 'edm/application/directive/prescribedDrugs/template/prescribed-drugs.html',
            link: function($scope, element, attr, formCtrl) {
                $scope.form = formCtrl;
                $scope.favouriteIcd9List = [];
                $scope.medicalProcedureHistoryList = [];
                $scope.doctorId = userModel.getCurrentContextDoctorId();
                $scope.allowedTypes = ['otcDrug'];
                $scope.isPreview = ($scope.template && $scope.template.user.id != userModel.currentUser.id);

                $scope.removeOTCDrug = function (prescribedDrug) {
                    if(!$scope.template) {
                        if($scope.visit.visitStatus === Enum.VISIT_STATUS.COMPLETED) {
                            if(!prescribedDrug.prescription) {
                                if(prescribedDrug.id) {

                                    var label = prescribedDrug.drug.name;
                                    var configPopup = {
                                        templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                                        controller: 'popupDeleteWithReasonController',
                                        controllerAs: 'deleteConfirmCtrl',
                                        skipHide: true,
                                        locals: {
                                            labels: label,
                                            item: prescribedDrug,
                                            userModel: userModel,
                                            $mdDialog: $mdDialog,
                                            message: 'T.MODULE.PATIENT.TAKEN_DRUG_DELETE_CONFIRMATION'
                                        }
                                    };

                                    $mdDialog.show(configPopup).then(function(data) {
                                        $scope.visitCard.prescribedDrugs.forEach(function(d, idx) {
                                            if(d.id === data.id) {
                                                $scope.visitCard.prescribedDrugs[idx] = angular.copy(data);
                                            }
                                        })
                                    });


                                } else {
                                    _.remove($scope.visitCard.prescribedDrugs, function(element) {
                                        return element === prescribedDrug;
                                    });
                                }
                            } else {
                                applicationModel.alert('T.DATA.ALERT', 'T.MODULE.PATIENT.TAKEN_DRUG_ALREADY_PRINTED');
                            }
                        } else if($scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS) {
                            if(!prescribedDrug.prescription || !prescribedDrug.alreadyPrinted) {
                                prescribedDrugModel.delete(prescribedDrug).then(function () {

                                    _.remove($scope.visitCard.prescribedDrugs, function(element) {
                                        return element === prescribedDrug;
                                    });
                                    visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                                        _.extend($scope.visitCard, visitCard);
                                    });
                                });
                            } else {
                                applicationModel.confirmWithReason($scope, 'T.MODULE.PATIENT.DELETE_TAKEN_DRUG', 'T.MODULE.VISIT.DELETE_PRESCRIPTION_DRUG_REASON', angular.copy(prescribedDrug)).then(function (prescribedDrug) {
                                    prescribedDrugModel.update(prescribedDrug).then(function () {
                                        visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                                            _.extend($scope.visitCard, visitCard);
                                        });
                                    });
                                });
                            }
                        }
                    } else {
                        _.remove($scope.template.prescribedDrugs, function(element) {
                            return element === prescribedDrug;
                        });
                    }
                };

                $scope.addDrugToOTCDrugs = function(drug) {
                    var localOtcDrug = new PrescribedDrugVO();

                    localOtcDrug.drug = new DrugVO();
                    localOtcDrug.drug.name = drug.name;
                    localOtcDrug.drug.commonName = drug.commonName;
                    localOtcDrug.drug.form = drug.form;
                    localOtcDrug.drug.strength = drug.strength;
                    localOtcDrug.count = 1;
                    localOtcDrug.drug.packages = drug.packages.map(function (p) {
                        return p.drugPackage;
                    });
                    localOtcDrug.drug.packing = localOtcDrug.drug.packages[0];


                    if(!$scope.template) {
                        updateOtcDrugs(localOtcDrug);
                    } else {
                        $scope.template.prescribedDrugs.push(localOtcDrug);
                    }
                };

                /**
                 * for drag&drop feature
                 * @param event
                 * @param index
                 * @param item
                 */
                $scope.dropOTCDrug = function(event, index, item) {
                    return item;
                };

                $scope.dndMoved = function (index) {
                    $scope.visitCard.prescribedDrugs.splice(index, 1);
                    updateOtcDrugs();
                };

                $scope.$watch('newOtcDrug', function(newVal, oldVal) {
                    if(!_.isUndefined(newVal) && newVal != null) {
                        $scope.addDrugToOTCDrugs(newVal);
                        $scope.newOtcDrug = undefined;
                    }
                });

                $scope.isVisitInProgress = function () {
                    return $scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS;
                };

                $scope.getPrescribedDrugs = function () {
                    if($scope.template) {
                        return $scope.template.prescribedDrugs;
                    } else {
                        return getPrescribedDrugsFromVisitCard();
                    }
                };

                $scope.drugPackageUpdate = function(drug, updateOnly) {
                    updateOtcDrugs(drug, updateOnly);
                };

                function getPrescribedDrugsFromVisitCard() {
                    return $scope.visitCard.prescribedDrugs.filter(function(drug) {
                        return !drug.prescription && !drug.deleted;
                    })
                }

                function updateOtcDrugs (drug, updateOnly) {
                    if(!$scope.template) {
                        if(drug.id && $scope.isVisitInProgress()) {
                            prescribedDrugModel.update(drug);
                        } else {
                            drug.patient = new PatientVO($scope.patient.id);
                            drug.visitCard = new VisitCardVO($scope.visitCard.id);
                            if($scope.isVisitInProgress()) {
                                prescribedDrugModel.save(drug).then(function (prescribedDrug) {
                                    $scope.visitCard.prescribedDrugs.push(prescribedDrug);
                                });
                            } else {
                                if(!updateOnly) {
                                    $scope.visitCard.prescribedDrugs.push(drug);
                                }
                            }
                        }
                    }
                }
            }
        };

        return definition;
    }
]);
